<ion-app>
  <nb-layout>
    <nb-layout-column>
      <ion-router-outlet></ion-router-outlet>
    </nb-layout-column>
  </nb-layout>
</ion-app>
